function setupConditionalFields() {
  document.querySelectorAll('.js-conditional-select').forEach(select => {
    const container = document.getElementById(select.dataset.target);
    if (!container) return;

    const toggleVisibility = () => {
      const shouldShow = select.value === select.dataset.expected;

      container.classList.toggle('d-none', !shouldShow);
      container.querySelectorAll('input, select, textarea').forEach(el => el.disabled = !shouldShow);
    };

    toggleVisibility();
    select.addEventListener('change', toggleVisibility);
  });
}

document.addEventListener('turbo:load', setupConditionalFields);
